export default __webpack_public_path__ + "static/media/Ellipse 111 (4).348738b8.png";